"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getNodeVersion() {
  return process.versions && process.versions.node ? "v" + process.versions.node : process.version;
}
exports.default = getNodeVersion;